import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=c4006728&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4006728')) {
      api.createRecord('c4006728', component.options)
    } else {
      api.reload('c4006728', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=c4006728&", function () {
      api.rerender('c4006728', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2bQNUTNdBW06q/JS/ImageCarousel.vue"
export default component.exports